interface AuthState {
  isAuthenticated: boolean;
  token: string;
  username: string;
}

const initialState: AuthState = {
  isAuthenticated: false,
  token: "",
  username: "",
};

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case "LOGIN":
      return {
        isAuthenticated: true,
        token: action.payload?.token || "",
        username: action.payload?.username || "",
      };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
